import React from 'react';
import eureka from 'eureka';
import { MessageStrip, MessageStripDesign } from '@ui5/webcomponents-react';
import { MicroFrontendProps } from 'src/types';

const { useTranslation } = eureka.I18nProvider;

type Params = { id: string };

const ErrorPage: React.FC<MicroFrontendProps<Params>> = (props) => {
  const { t } = useTranslation();
  const uuid = props.match.params.id;
  let errorType = 'general';
  if (!uuid) {
    errorType = 'general';
  } else if (
    /[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}/gi.test(uuid)
  ) {
    // 00001513-1212-EFDE-1523-785DEABCD122
    errorType = uuid;
  } else if (uuid.trim() === 'user-not-found') {
    errorType = 'user-not-found';
  } else if (uuid.trim() === 'tenant-not-found') {
    errorType = 'tenant-not-found';
  } else {
    errorType = uuid;
  }
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <div style={{ width: '300px', height: '200px' }}>
        <MessageStrip hideCloseButton hideIcon={false} design={MessageStripDesign.Negative}>
          {t('Error_ErrorHappened')}
          <br />
          {t('Error_ErrorType')}: {errorType}
          <br />
          {t('Error_ErrorTips')}
        </MessageStrip>
      </div>
    </div>
  );
};

export default ErrorPage;
